@let unitToUpdate = workingUnit();
@if (unitToUpdate) {
  <div class="content">
    <div class="systemInputs">
      <div class="selectionFields inputPanel">
        <div class="inputButtonRow">
          <label class="inputLabel">Unit Type:</label>
          <select class="inputSelection" [(ngModel)]="unitToUpdate.productId" (change)="productIdChanged()"
            [disabled]="isBusy()">
            <option [value]="''" [selected]="!unitToUpdate.productId"></option>
            @for (productId of productIds(); track productId) {
              <option [value]="productId">{{ productId }}</option>
            }
          </select>
          @if (schedule()) {
            <span>
              <label class="sizeLabel">Quantity:</label>
              <input class="quantityInput" type="number" [(ngModel)]="quantity" [disabled]="isBusy()"
                (ngModelChange)="quantityUpdated()"/>
              @if (schedule()) {
                <button matButton="elevated" class="inputButton"
                  [disabled]="isBusy() || quantity() === 0" (click)="showTagsDialog()">
                  Update Tags
                </button>
              }
            </span>
          }
          @if (!schedule()) {
            <span>
              <label class="inputLabel">Notes:</label>
              <input class="notesInput" [(ngModel)]="unitToUpdate.notes" [disabled]="isBusy()"/>
            </span>
          }
        </div>
        @if (availableModels() && availableModels().length > 0) {
          <div class="inputRow">
            @if (availableModels() && availableModels().length > 0) {
              <span>
                <label class="inputLabel">Unit Style:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.modelCode" (change)="selectedModelChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.modelCode"></option>
                  @for (model of availableModels(); track model) {
                    <option [value]="model.modelCode">
                      {{ model.modelCode + ' - ' + model.description }}
                    </option>
                  }
                </select>
              </span>
            }
            @if (unitToUpdate.modelCode && availableSizes() && availableSizes().length > 0) {
              <span>
                <label class="inputLabel">Size:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.sizeCode" (change)="selectedSizeChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.sizeCode"></option>
                  @for (size of availableSizes(); track size) {
                    <option [value]="size.sizeCode">{{ size.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (unitToUpdate.modelCode) {
          <div class="inputRow">
            @if (unitToUpdate.modelCode && systemTypes()?.length > 0) {
              <span>
                <label class="inputLabel">System Type:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.systemTypeCode" (change)="systemTypeChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.systemTypeCode"></option>
                  @for (systemType of systemTypes(); track systemType) {
                    <option
                    [value]="systemType.Value">{{ systemType.Description }}</option>
                  }
                </select>
              </span>
            }
            @if (coilRows() && coilRows().length > 0) {
              <span>
                <label class="inputLabel">Coil Rows:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.coilRowCode" (change)="coilRowsChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.coilRowCode"></option>
                  @for (coilRow of coilRows(); track coilRow) {
                    <option [value]="coilRow.code">{{ coilRow.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (unitToUpdate.modelCode) {
          <div class="inputRow">
            @if (availableMotorVoltages() && availableMotorVoltages().length > 0) {
              <span>
                <label class="inputLabel">Unit Power Supply:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.powerSupplyCode"
                  (change)="selectedMotorVoltageChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.powerSupplyCode"></option>
                  @for (voltage of availableMotorVoltages(); track voltage) {
                    <option
                    [value]="voltage.code">{{ voltage.description }}</option>
                  }
                </select>
              </span>
            }
            @if (availableMotorTypes() && availableMotorTypes().length > 0) {
              <span>
                <label class="inputLabel">Motor Type:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.motorTypeCode" (change)="selectedMotorTypeChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.motorTypeCode"></option>
                  @for (motorType of availableMotorTypes(); track motorType) {
                    <option
                    [value]="motorType.guruModelValue">{{ motorType.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (unitToUpdate.modelCode) {
          <div class="inputRow">
            @if ((availablePrimaryCoilCircuits()?.length ||0) > 0) {
              <span>
                <label class="inputLabel">Primary Coil Circuit:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.primaryCoilCircuits"
                  (change)="primaryCircuitsChanged()" [disabled]="isBusy()">
                  @for (circuit of availablePrimaryCoilCircuits(); track circuit) {
                    <option
                    [value]="circuit.code">{{ circuit.description }}</option>
                  }
                </select>
              </span>
            }
            @if ((availableSecondaryCoilCircuits()?.length ||0) > 0) {
              <span>
                <label class="inputLabel">Secondary Coil Circuit:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.secondaryCoilCircuits"
                  (change)="secondaryCircuitsChanged()" [disabled]="isBusy()">
                  @for (circuit of availableSecondaryCoilCircuits(); track circuit) {
                    <option
                    [value]="circuit.code">{{ circuit.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
        @if (unitToUpdate.modelCode) {
          <div class="inputRow">
            @if (availableFilters() && availableFilters().length > 0) {
              <span>
                <label class="inputLabel">Air Filter:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.request.Filter"
                  (change)="filterTypeChanged()" [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.request.Filter"></option>
                  @for (filter of availableFilters(); track filter) {
                    <option [value]="filter.code">{{ filter.description }}</option>
                  }
                </select>
              </span>
            }
            @if (availableElectricHeatKw() && availableElectricHeatKw().length > 0) {
              <span>
                <label class="inputLabel">Electric Heat KW:</label>
                <select class="inputSelection" [(ngModel)]="unitToUpdate.electricHeatCode" (change)="electricHeatKwChanged()"
                  [disabled]="isBusy()">
                  <option [value]="null" [selected]="!unitToUpdate.electricHeatCode"></option>
                  @for (kw of availableElectricHeatKw(); track kw) {
                    <option [value]="kw.code">{{ kw.description }}</option>
                  }
                </select>
              </span>
            }
          </div>
        }
      </div>
    </div>
    @if (unitToUpdate.modelCode) {
      <div class="imageContainer">
        <img class="unitImage" [src]="getModelImageFileName()" alt=""/>
      </div>
    }
    @if (unitToUpdate.modelCode && coilRows()?.length > 0 && unitToUpdate.request) {
      <div class="performanceInput">
        <app-schedule-line-performance-input [request]="unitToUpdate.request" [isAirHandler]="isAirHandlerModel()"
          (selectionChange)="performanceInputChanged()">
        </app-schedule-line-performance-input>
      </div>
    }
    @if (unitToUpdate.modelCode && unitToUpdate.response) {
      <div class="performanceOutput">
        <app-schedule-line-performance-output [response]="unitToUpdate.response" [isAirHandler]="isAirHandlerModel()"
          [isMetric]="unitToUpdate.request.IsMetricInput"
          [isSureflow]="isSureflowModel()">
        </app-schedule-line-performance-output>
      </div>
    }
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait</label>
    </div>
  </div>
}
